import type { Money } from '@libs/trip-planner-interfaces';

export interface TripSummarySegment {
  title: string;
  price: TripSummarySegmentPrice[];
}

export interface TripSummarySegmentPrice {
  description: string;
  value: string;
  amount: number;
  type: 'ingredient' | 'addon';
}

export const enum TripSummaryPriceType {
  Total = 'total',
  TotalGross = 'totalGross',
  TotalAlternative = 'totalAlternative',
  TotalGrossAlternative = 'totalGrossAlternative',
}

export interface TripSummaryPrice {
  totalPrice: Money | undefined;
  grossPrice: Money | undefined;
  priceType: TripSummaryPriceType;
}
